import { render } from "./ConnectionsTableHtml.vue?vue&type=template&id=19fef37b&scoped=true&ts=true"
import script from "./ConnectionsTableHtml.vue?vue&type=script&lang=ts"
export * from "./ConnectionsTableHtml.vue?vue&type=script&lang=ts"

import "./ConnectionsTableHtml.vue?vue&type=style&index=0&id=19fef37b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fef37b"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QMenu,QCard,QCardSection,QCardActions,QBtn});qInstall(script, 'directives', {ClosePopup});
